import { Typography } from 'antd';
import React from 'react';
import styles from './index.module.css';

interface Props {
  message?: string;
}

export default ({ message = 'The requestet page could not be found' }: Props) => {
  return (
    <section className={styles.wrapper}>
      <Typography.Title className={styles.title404}>404</Typography.Title>
      <Typography.Text className={styles.message}>{message}</Typography.Text>
    </section>
  );
};
